module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"slogan":"Huntica — сервис виртуальных собеседований с человеческим лицом","description":"Удобный интерфейс позволяет быстро создавать вакансии, на которые кандидаты будут записывать видео-отклики. Приглашайте кандидатов из личного кабинета, с помощью расширения для Chrome, или разместите открытую вакансию, на которую сможет откликнуться любой желающий."}}')
  delete Component.options._Ctor
}
